(function() {
  const menuButtons = document.querySelectorAll('.menu-click');
  const mobileMenu = document.getElementById('mobileMenu');
  const overlay = document.getElementById('mobileMenuOverlay');
  const body = document.body;

  menuButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const isHidden = mobileMenu.classList.contains('translate-x-full');
      if (isHidden) {
        mobileMenu.classList.remove('translate-x-full');
        overlay.classList.remove('hidden');
        body.classList.add('overflow-hidden');
      } else {
        mobileMenu.classList.add('translate-x-full');
        overlay.classList.add('hidden');
        body.classList.remove('overflow-hidden');
      }
    });
  });

  overlay.addEventListener('click', () => {
    mobileMenu.classList.add('translate-x-full');
    overlay.classList.add('hidden');
    body.classList.remove('overflow-hidden');
  });
})();